/**
 * Returns a property from an object.
 */
export function ReduceToPropertyFilter() {
  return function(input, propertyName) {
    return input[propertyName];
  };
}
